import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Howl, Howler } from "howler";
import BetPlacedChip from "../../../../../../library/Chips/BetChip";
import PaiGowCardsContainer from "./PaiGowCardsContainer";


import paiGowTableWindows from "../../../../../../assets/games/PaiGow/paiGowTableWindows.webp"
import paiGowTableLandscape from "../../../../../../assets/games/PaiGow/paiGowTableLandscape.webp"
import paiGowTablePotrait from "../../../../../../assets/games/PaiGow/paiGowTablePotrait.webp"

import betChipSnd from "../../../../../../assets/sounds/betoncard.mp3"
import CardFallSnd from "../../../../../../assets/sounds/slide.mp3"
import dealerCardsSnd from "../../../../../../assets/sounds/dealercards_reavel.mp3"
import CardSelectSnd from "../../../../../../assets/sounds/selectcard.mp3"
import CardInvalidSelectSnd from "../../../../../../assets/sounds/alert.mp3"
import msgSnd from "../../../../../../assets/sounds/coindrop_old.mp3"
import clearSnd from "../../../../../../assets/sounds/clear.mp3"
import loseSnd from "../../../../../../assets/sounds/duplose.mp3"
import btnClickSnd from "../../../../../../assets/sounds/buttonClick.mp3"
import menuSnd from "../../../../../../assets/sounds/checkbox.mp3"
import pokerChipSnd from "../../../../../../assets/sounds/pokerChip.mp3"
import glowSnd from "../../../../../../assets/sounds/successNew.mp3"

const PaiGowGameBoard = forwardRef((props, ref) => {
    const [animatedChips, setAnimatedChips] = useState([])
    const [reverseAnimatedChips, setReverseAnimatedChips] = useState([])
    const debounceRef = useRef(false);
    const playerCardsRef = useRef()
    const dealerCardsRef = useRef()
    const [winMessage, setWinMessage] = useState("")
    const [allowAnte, setAllowAnte] = useState(false)
    const [undoChipsArray, setUndoChipsArray] = useState([])
    // const [cardFallSound, setCardFallSound] = useState(new Howl({ src: [CardFallSnd], html5: true, }))
    // const [dealerCardRevealSound, setDealerCardRevealSound] = useState(new Howl({ src: [dealerCardsSnd], html5: true, }))
    // const [cardClickSound, setCardClick] = useState(new Howl({ src: [CardSelectSnd], html5: true, }))
    // const [betChipSound, setBetChipSound] = useState(new Howl({ src: [betChipSnd], html5: true, }))
    // const [CardInvalidSelectSound, setInvalidSelectSound] = useState(new Howl({ src: [CardInvalidSelectSnd], html5: true, }))
    // const [messageSound, setMessageSound] = useState(new Howl({ src: [msgSnd], html5: true, }))
    // const [clearSound, setClearSound] = useState(new Howl({ src: [clearSnd], html5: true, }))

    const tableRef = useRef();
    const soundsRef = useRef({});
    const standRef = useRef();
    const dealRef = useRef();
    const betRef = useRef();

    useImperativeHandle(ref, () => ({
        startDealingCards,
        revealDealerCards,
        setWinMessage,
        setAllowAnte,
        setHandMessages: (res) => {
            if (res) {
                soundSuspendedChecker();
                soundSuspendedChecker();
                soundsRef.current?.messageSound?.stop()
                soundsRef.current?.messageSound?.play()
                playerCardsRef?.current.setHandMessages({ hand1: res.playerHand1, hand2: res.playerHand2 })
                dealerCardsRef?.current.setHandMessages({ hand1: res.dealerHand1, hand2: res.dealerHand2 })
            } else {
                playerCardsRef?.current.setHandMessages({ hand1: "", hand2: "" })
                dealerCardsRef?.current.setHandMessages({ hand1: "", hand2: "" })
            }
        },
        clearAllCards,
        setTableImage,
        toggleMute: (newMuteState) => { Howler?.mute(newMuteState); },
        setDealt: (res) => {
            playerCardsRef.current.setIsDealt(res)
            dealerCardsRef.current.setIsDealt(res)
        },
        setAllCards: (res) => {
            playerCardsRef.current.setAllCards(res)
            dealerCardsRef.current.setAllCards(res)
        },
        playerAllowClick: (res) => {
            playerCardsRef.current.setAllowClick(res)
        },
        // playLostSound: () => {
        //     soundSuspendedChecker();
        //     soundsRef.current?.lostSound?.stop()
        //     soundsRef.current?.lostSound?.play()
        // },
        playMenuSound: () => {
            soundSuspendedChecker();
            soundsRef.current?.menuSound?.stop()
            soundsRef.current?.menuSound?.play()
        },
        playWinGlowSound: () => {
            soundSuspendedChecker();
            soundsRef.current?.winGlowSound?.stop()
            soundsRef.current?.winGlowSound?.play()
        },
        playChipSound: () => {
            soundSuspendedChecker();
            soundsRef.current?.pokerChipSound?.stop()
            soundsRef.current?.pokerChipSound?.play()
        }
    }))


    useEffect(() => {
        Howler?.mute(false);
        Howler.volume(1);
        Howler.autoUnlock = true;
        Howler.autoSuspend = false;

        document.addEventListener("visibilitychange", (event) => {
            event.preventDefault();
            soundSuspendedChecker();
        });

        const unlock = () => {
            if (!soundsRef.current?.cardFallSound) {
                soundsRef.current = {
                    cardFallSound: new Howl({ src: [CardFallSnd], html5: false, preload: true }),
                    dealerCardRevealSound: new Howl({ src: [dealerCardsSnd], html5: false, preload: true }),
                    cardClickSound: new Howl({ src: [CardSelectSnd], html5: false, preload: true }),
                    betChipSound: new Howl({ src: [betChipSnd], html5: false, preload: true }),
                    CardInvalidSelectSound: new Howl({ src: [CardInvalidSelectSnd], html5: false, preload: true }),
                    messageSound: new Howl({ src: [msgSnd], html5: false, preload: true }),
                    clearSound: new Howl({ src: [clearSnd], html5: false, preload: true }),
                    lostSound: new Howl({ src: [loseSnd], html5: false, preload: true }),
                    btnClickSound: new Howl({ src: [btnClickSnd], html5: false, preload: true }),
                    menuSound: new Howl({ src: [menuSnd], html5: false }),
                    pokerChipSound: new Howl({ src: [pokerChipSnd], html5: false, preload: true }),
                    winGlowSound: new Howl({ src: [glowSnd], html5: false, preload: true }),
                };
            }

        };

        window.addEventListener("touchstart", unlock, { once: true });
        window.addEventListener("click", unlock, { once: true });
        return () => {
            window.removeEventListener("touchstart", unlock);
            window.removeEventListener("click", unlock);
            document.removeEventListener("visibilitychange", () => { });

            for (let key in soundsRef.current) {
                if (key) {
                    soundsRef.current[key].stop()
                    soundsRef.current[key].unload()
                }
            }

        }
    }, []);

    const soundSuspendedChecker = () => {
        if (document.visibilityState === 'visible' && Howler.ctx && (Howler.ctx.state === 'suspended' || Howler.ctx.state !== 'running')) {
            Howler.ctx.resume();
        }
        Howler._audioUnlocked = true;
    }

    const debounce = (callback, delay) => {
        let timer
        return function () {
            clearTimeout(timer)
            timer = setTimeout(() => {
                callback();
            }, delay)
        }
    }

    const setInitialImage = () => {
        const backTable = new Image()

        backTable.onload = () => {
            if (tableRef.current) {
                tableRef.current.style.backgroundImage = `url(${backTable.src})`;
            }
            props.assestsLoaderFunction(); // only once when image first loads
        };

        switch (props.orientation) {
            case "windows":
                backTable.src = paiGowTableWindows;
                break;
            case "landscape":
                backTable.src = paiGowTableLandscape;
                break;
            case "portrait":
                backTable.src = paiGowTablePotrait;
                break;
            default:
                break;
        }
    };



    const setTableImage = () => {
        if (!tableRef.current.style.backgroundImage) {
            // first time → load and trigger callback
            setInitialImage();
        } else {
            // just swap to already preloaded image (no reload, instant swap)
            switch (props.orientation) {
                case "windows":
                    tableRef.current.style.backgroundImage = `url(${paiGowTableWindows})`;
                    break;
                case "landscape":
                    tableRef.current.style.backgroundImage = `url(${paiGowTableLandscape})`;
                    break;
                case "portrait":
                    tableRef.current.style.backgroundImage = `url(${paiGowTablePotrait})`;
                    break;
                default:
                    break;
            }
        }
    };


    const startChipAnimation = () => {
        if (debounceRef.current) return true;
        debounceRef.current = true;

        const chipId = Date.now(); // unique id
        setAnimatedChips((prev) => [...prev, chipId]);
        soundSuspendedChecker();
        soundsRef.current?.betChipSound?.stop()
        soundsRef.current?.betChipSound?.play()

        setTimeout(() => {
            setAnimatedChips((prev) => prev.filter((id) => id !== chipId));
            debounceRef.current = false;
        }, 200);
    };

    const reverseChipAnimation = (amount) => {
        if (debounceRef.current) return;
        debounceRef.current = true;

        const chipId = Date.now(); // unique id
        setReverseAnimatedChips((prev) => [...prev, { chipId, amount }]);
        soundSuspendedChecker();
        soundsRef.current?.betChipSound?.stop()
        soundsRef.current?.betChipSound?.play()

        setTimeout(() => {
            setReverseAnimatedChips((prev) => prev.filter((ele) => ele.chipId !== chipId));
            debounceRef.current = false;
        }, 180);
    };

    const clearAllCards = () => {
        standRef.current = false
        dealRef.current = false
        betRef.current = false
        playerCardsRef.current.clearAllCards()
        dealerCardsRef.current.clearAllCards()
    }

    const handleOnClick = (type) => {
        console.log(type)
        soundSuspendedChecker();
        soundsRef.current?.btnClickSound?.stop()
        soundsRef.current?.btnClickSound?.play()

        switch (type) {
            case "Clear": clickOnClearBtn(); break;
            case "Deal": clickOnDealBtn(); break;
            case "Undo": clickOnUndoBtn(); break;
            case "Bet": clickOnBetBtn(); break;
            case "Stand": clickOnStandBtn(); break;
            case "Rebet": clickOnRebetBtn("rebet"); break;
            case "Rebet X2": clickOnRebetBtn("rebetx2"); break;
            default: break;
        }
    }

    const clickOnDealBtn = () => {
        if (props.betAmount >= props.pg_minBet &&
            props.betAmount <= props.pg_maxBet) {
            if (!dealRef.current) {
                props.setInfoText(props.language.wait_cards_dealt)
                props.setIsIncDecChips(true)
                props.setBetBtn("")
                props.setClearBtn("")
                props.setUndoBtn("")
                setAllowAnte(false)
                clearAllCards()
                const body = {
                    "sessionId": sessionStorage.getItem("sessionId"),
                    "CN": "PAIGOW_BET",
                    "object": {
                        "gameId": Number(props.gameId),
                        "playerId": props.playerId,
                        "betAmount": Number(props.betAmount).toFixed(2),
                        "action": "PARAM_BET",
                        "handId": Number(props.gameState.handId)
                    },
                }
                props.network.sendof(body);
                dealRef.current = true
            }
        } else {
            if (props.betAmount > Number(props.balance)) {
                props.setInfoText(props.language.LowFunds);
            } else if (props.betAmount > props.pg_maxBet) {
                props.setInfoText(`${props.language.MaxInrBetAmt}${props.pg_maxBet}`);
            } else if (props.betAmount < props.pg_minBet) {
                props.setInfoText(`${props.language.InerLmt}${props.pg_minBet}`);
            }
            soundSuspendedChecker();
            soundsRef.current?.CardInvalidSelectSound?.stop()
            soundsRef.current?.CardInvalidSelectSound?.play()
        }
    }

    const clickOnStandBtn = () => {
        if (!standRef.current) {
            const body = {
                "sessionId": sessionStorage.getItem("sessionId"),
                "CN": "PAIGOW_BET",
                "object": {
                    "gameId": Number(props.gameId),
                    "playerId": props.playerId,
                    "intSplit": playerCardsRef.current.getPlayerSecondHandCards(),
                    "action": "PARAM_SPLIT",
                    "handId": Number(props.gameState.handId)
                },
            }
            props.setInfoText(props.language.Bet_Processing_Msg)
            props.network.sendof(body);
            standRef.current = true
            props.setBetBtn("")
            playerCardsRef?.current?.setAllowClick(false)
        }
    }


    const clickOnBetBtn = () => {
        // console.log("_______________________________________________________________")
        const chipValue = Number(props.chipsArray.split(",")[props.selectedChip]);
        const currentBet = Number(props.betAmount);
        const newBetAmount = Number((chipValue + currentBet).toFixed(2));
        // console.log(newBetAmount <= Number(props.balance), newBetAmount <= props.pg_maxBet, newBetAmount >= props.pg_minBet)
        // console.log("_______________________________________________________________")
        if (newBetAmount <= Number(props.balance) && newBetAmount <= props.pg_maxBet) {
            // 1. Add the amount first

            // 2. Then animate the chip
            let chipAnimation = startChipAnimation();

            if (!chipAnimation) {
                setTimeout(() => {

                    props.setBetAmount(newBetAmount);
                    setUndoChipsArray((prev) => [...prev, chipValue])
                    if (newBetAmount >= props.pg_minBet && props.betBtn === "Bet") {
                        props.setBetBtn("Deal")
                        props.setClearBtn("Clear")
                        props.setUndoBtn("Undo")
                    }
                }, 200)
            }
            if (newBetAmount >= 1 && props.betBtn === "Bet") {
                props.setBetBtn("")
            }
            // 3. Update info text
            props.setInfoText(`${props.language.MinBetAmt} ${props.pg_minBet} ${props.language.MaxBetAmt} ${props.pg_maxBet}`);
        } else {
            if (newBetAmount > Number(props.balance)) {
                props.setInfoText(props.language.LowFunds);
            } else if (newBetAmount > props.pg_maxBet) {
                props.setInfoText(`${props.language.MaxInrBetAmt}${props.pg_maxBet}`);
            } else if (newBetAmount < props.pg_minBet) {
                props.setInfoText(`${props.language.InerLmt}${props.pg_minBet}`);
            }
            soundSuspendedChecker();
            soundsRef.current?.CardInvalidSelectSound?.stop()
            soundsRef.current?.CardInvalidSelectSound?.play()
        }
    };

    const clickOnRebetBtn = (type) => {

    }

    const clickOnUndoBtn = () => {
        const undoChips = [...undoChipsArray]
        const [lastChip] = undoChips.splice(undoChips.length - 1, 1)
        const newBetAmt = Number((props.betAmount - lastChip).toFixed(2))
        if (newBetAmt >= 0) {
            props.setBetAmount(newBetAmt)
            setUndoChipsArray([...undoChips])
            reverseChipAnimation(lastChip)
            if (newBetAmt == 0) {
                props.setUndoBtn("")
                props.setBetBtn("Bet")
                props.setClearBtn("")
            }
        }
    }

    const clickOnClearBtn = () => {
        soundSuspendedChecker();
        soundsRef.current?.clearSound?.stop()
        soundsRef.current?.clearSound?.play()
        props.setBetAmount(0);
        props.setBetBtn("Bet")
        props.setClearBtn("")
        props.setUndoBtn("")
        props.setInfoText(props.language.Place_antebet)
        reverseChipAnimation(props.betAmount)
    }

    const startDealingCards = (res) => {
        // console.log("Setting All Cards")
        playerCardsRef?.current?.setPlayerAllCards(res?.playerCards)
        setTimeout(() => {
            dealerCardsRef?.current?.setDealerUnsetCards(res?.dealerCards[0].split(','))
            setTimeout(() => {
                playerCardsRef?.current?.setAllowClick(true)
                props.setInfoText(props.language.select_second_hand)
            }, 3000)
        }, 3000)
    }

    const revealDealerCards = (res) => {
        dealerCardsRef?.current?.revealDealerCards(res)
    }

    return <>
        <div id="paiGowTable" ref={tableRef}>
            <div id="cardDispenser"></div>
            <div id="tableCenterCircle" onClick={() => { allowAnte && clickOnBetBtn() }}>
                <span id="anteText">{props.language.Ante || "Ante"}</span>
                {props.betAmount !== 0 && <button disabled={!allowAnte} className="betPlacedChipBox">
                    <BetPlacedChip chipWidth="100%" chipHeight="100%" betAmount={props.betAmount} chipString={props.chipsArray} gameId={Number(props.gameId)}></BetPlacedChip>
                </button>}
                {winMessage && <div id="winMessage">{winMessage.replaceAll('_', " ")}</div>}
            </div>
            {animatedChips.map((chipId) => (
                <div key={chipId} className="betAnimationChip" style={{ "--selectedChip": props.selectedChip }}>
                    <BetPlacedChip chipWidth="100%" chipHeight="100%" betAmount={props.chipsArray.split(",")[props.selectedChip]} chipString={props.chipsArray} gameId={Number(props.gameId)} />
                </div>
            ))}
            {reverseAnimatedChips.map((ele) => (
                <div key={ele.chipId} className="reverseBetAnimationChip" style={{ "--selectedChip": props.chipsArray.split(",").indexOf(`${ele.amount}`) }}>
                    <BetPlacedChip chipWidth="100%" chipHeight="100%" betAmount={ele.amount} chipString={props.chipsArray} gameId={Number(props.gameId)} />
                </div>
            ))}
            <div id="dealerCardsContainer">
                {/* <PaiGowCardsContainer ref={dealerCardsRef} setBetBtn={props.setBetBtn} cardFallSound={cardFallSound} dealerCardRevealSound={dealerCardRevealSound}></PaiGowCardsContainer> */}
                <PaiGowCardsContainer ref={dealerCardsRef} language={props.language} setBetBtn={props.setBetBtn} soundsRef={soundsRef}></PaiGowCardsContainer>
            </div>
            <div id="playerCardsContainer">
                {/* <PaiGowCardsContainer setInfoText={props.setInfoText} language={props.language} ref={playerCardsRef} isPlayer={true} setBetBtn={props.setBetBtn} cardFallSound={cardFallSound} cardClickSound={cardClickSound} CardInvalidSelectSound={CardInvalidSelectSound}></PaiGowCardsContainer> */}
                <PaiGowCardsContainer setInfoText={props.setInfoText} language={props.language} ref={playerCardsRef} isPlayer={true} setBetBtn={props.setBetBtn} soundsRef={soundsRef}></PaiGowCardsContainer>
            </div>

            <div className="actionBtnsBox">
                {props.clearBtn && <div id="rebetBtn" className="actionButtons" onClick={() => { handleOnClick(props.clearBtn) }}><button className="actionButtonsBtn" type="button" style={{ "--btnBackClr": "rgba(0 150 255/50)", "--btnClr": "#004c87" }} ><span>{props.language[props.clearBtn]}</span></button></div>}
                {props.betBtn && <div id="betBtn" className="actionButtons" onClick={() => { handleOnClick(props.betBtn) }}><button className="actionButtonsBtn" type="button" style={{ "--btnBackClr": "#2de92d80", "--btnClr": "#117d1d" }} ><span>{props.language[props.betBtn]}</span></button></div>}
                {props.undoBtn && <div id="clearBtn" className="actionButtons" onClick={() => { handleOnClick(props.undoBtn) }}><button className="actionButtonsBtn" type="button" style={{ "--btnBackClr": "rgba(208 0 65 /50)", "--btnClr": "#7c0026" }} ><span>{props.language[props.undoBtn]}</span></button></div>}
            </div>
        </div>
    </>
})

export default PaiGowGameBoard